import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, SwitchInvestmentModelIcon, Text, useResponsive } from '@common-fe/common-fe';

import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';

import { InvestmentPaths } from '../../investments.types';

interface Props {
  modelType?: InvestmentPaths;
}
const InvestmentSwitchingModelBanner: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  return (
    <Box
      direction="column"
      pad={isMobile ? 'spacing16' : 'spacing24'}
      background="border1"
      round="moduleRound"
      data-testId="investment-switching"
    >
      <Banner
        isWideMode
        title={t('Your Investment Settings are Updating')}
        description={
          <>
            <Text size="medium">
              {t('Updating your investment model will take 3 - 4 business days to complete.')}
            </Text>
            <Text size="medium">
              {t('During that time you will not be able to make changes to your investment portfolio.')}
            </Text>
          </>
        }
        icon={<SwitchInvestmentModelIcon />}
        testId="investment-switching"
      />
    </Box>
  );
};
export default InvestmentSwitchingModelBanner;
